"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadFile;

var _getSignedUrl = _interopRequireWildcard(require("./queries/getSignedUrl"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** @module uploadFile */

/* Retrieve S3 URL from the network */
async function getS3Url({
  apiClient,
  bucketKey,
  action,
  organisationId
}) {
  if (!organisationId) {
    throw new Error('You must either provide an organisationId or there must be a selected organisation to upload a file.');
  } // Call api using graphql-request apiClient


  if (apiClient.request) {
    const {
      getS3SignedUrl
    } = await apiClient.request(_getSignedUrl.getSignedUrlQuery, {
      bucketKey,
      organisationId,
      action
    });
    return getS3SignedUrl;
  } // Call api using apollo-client apiClient


  const {
    data,
    errors
  } = await apiClient.query({
    variables: {
      action,
      bucketKey,
      organisationId
    },
    query: _getSignedUrl.default,
    context: {
      module: 'assets'
    }
  });

  if (errors && errors.length) {
    throw new Error(errors[0].message);
  }

  return data.getS3SignedUrl;
}
/**
 * Uploads a file to a S3 bucket
 *
 * @param {*} file
 *
 * @return {Promise<*>}
 */


async function uploadFile({
  apiClient,
  file,
  bucketKey,
  organisationId
}) {
  if (!apiClient) {
    throw new Error('Must provide an apollo API client');
  }

  if (!file || !file.name) {
    throw new Error('Must provide file name');
  }

  const putUrl = await getS3Url({
    apiClient,
    bucketKey,
    action: 'put',
    organisationId
  }); // Upload file to s3

  await fetch(putUrl, {
    method: 'PUT',
    body: file
  });
}